import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  Message,
  MessageListResponse,
  SendMessage,
} from "@breeze/shared";
import { fetchMessages, sendMessage } from "../api.js";

export function useMessages(
  cardId: number | null
): ReturnType<typeof useQuery<MessageListResponse>> {
  return useQuery<MessageListResponse>({
    queryKey: ["messages", cardId],
    queryFn: () => fetchMessages(cardId as number),
    enabled: cardId !== null,
  });
}

export function useSendMessage(
  cardId: number | null
): ReturnType<
  typeof useMutation<{ message: Message }, Error, SendMessage>
> {
  const qc = useQueryClient();
  return useMutation<{ message: Message }, Error, SendMessage>({
    mutationFn: sendMessage,
    onSuccess: (data) => {
      if (cardId === null) return;
      qc.setQueryData<MessageListResponse>(["messages", cardId], (prev) => {
        if (!prev) return { messages: [data.message] };
        // De-dupe by msgId in case SSE arrived first.
        if (prev.messages.some((m) => m.msgId === data.message.msgId)) return prev;
        return { messages: [data.message, ...prev.messages] };
      });
    },
  });
}
